import type { QueryResult } from '@apollo/react-hooks';
import { gql, useQuery } from '@apollo/react-hooks';
import { getDashboardStats } from '#/graphql/queries';
import { DashboardStatsInput, GetDashboardStatsQuery } from '#/graphql/types';
import useSession from '#/common/hooks/useSession';

const q = gql(getDashboardStats);

const useStatsQuery = (
  stats: DashboardStatsInput,
  userId?: string,
  options?: { skip?: boolean; tenantIDs?: string[] },
): QueryResult<GetDashboardStatsQuery> => {
  const query: QueryResult<GetDashboardStatsQuery> = useQuery(q, {
    variables: { stats, userId, tenantIDs: options?.tenantIDs },
    skip: options?.skip,
  });

  const { data } = query;
  const dashboardStats = data?.getDashboardStats ?? {};

  return {
    ...query,
    data: {
      ...data,
      getDashboardStats: dashboardStats,
    },
  } as QueryResult<GetDashboardStatsQuery>;
};

export default useStatsQuery;
